<div class="container">
  <nav class="main-nav">
    <!-- <a class="sub-titulo" href="#" routerLink="/"><img src="../../assets/Griffo.png" -->
    <a href="/" class="sub-titulo"><img src="../../assets/Griffo.png" alt="Descrição da imagem">E-Transport</a>
    <div id="navbarNav">
      <div class="menu-items">


        <!-- <div class="dropdown" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
        <button [disabled]="isCarrierTCMEnabled" (click)="navigateTo('/milk_sul')">Milk Run Sul</button>
        </div> -->
        <div class="dropdown separado" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
          <button class="dropbtn">Milk Run</button>
          <div class="dropdown-content" *ngIf="showDropdown">
            <div class="dropdown" (mouseenter)="showDropdownTCM = true" (mouseleave)="showDropdownTCM = false">
              <button class="btn btn-dropdown">Milk Run TCM</button>
              <div class="dropdown-content-sub" *ngIf="showDropdownTCM">
                <button class="btn btn-dropdown" (click)="navigateTo('/milk_sul')">Acompanhar
                  Operação</button>
                <button class="btn btn-dropdown" (click)="navigateTo('/jettaTCM-SP')">Sinc
                  Jetta SP INT</button>
              </div>
            </div>

            <div class="dropdown" (mouseenter)="showDropdownJSL = true" (mouseleave)="showDropdownJSL = false">
              <button class="btn btn-dropdown">Milk Run JSL</button>
              <div class="dropdown-content-sub" *ngIf="showDropdownJSL" (mouseenter)="showDropdownJSL = true"
                (mouseleave)="showDropdownJSL = false">
                <button class="btn btn-dropdown" (click)="navigateTo('/milk_SP')">Acompanhar
                  Operação</button>
                <button class="btn btn-dropdown" (click)="navigateTo('/jettaTCM')">Sinc
                  Jetta SUL</button>
                <button class="btn btn-dropdown" (click)="navigateTo('/jetta')">Sinc
                  Jetta SP</button>
                <!-- <button class="btn btn-dropdown" [disabled]="isCarrierJSLEnabled" (click)="navigateTo('/jetta')">Sinc
            Jetta</button> -->
              </div>
            </div>

            <div class="dropdown" (mouseenter)="showDropdownLATINET = true" (mouseleave)="showDropdownLATINET = false">
              <button class="btn btn-dropdown">Milk Run LATINET</button>
              <div class="dropdown-content-sub" *ngIf="showDropdownLATINET" (mouseenter)="showDropdownLATINET = true"
                (mouseleave)="showDropdownLATINET = false">
                <button class="btn btn-dropdown" (click)="navigateTo('/milk_ARG')">Acompanhar Operação</button>
                <button class="btn btn-dropdown" (click)="navigateTo('/milk_ARG_Embalagem')">Acompanhar
                  Embalagens</button>
                <button class="btn btn-dropdown" (click)="navigateTo('/atualiza')">Sinc
                  Excel</button>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="dropdown" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
        <button [disabled]="isCarrierJSLARGEnabled" (click)="navigateTo('/milk_ARG')">Milk Run
          Argentina</button>
        </div> -->

        <div class="dropdown separado" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
          <button class="dropbtn">Interplantas</button>
          <div class="dropdown-content" *ngIf="showDropdown">
            <button class="btn btn-dropdown" (click)="navigateTo('/interplantas')">Acompanhar Operação</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/timeTableLOTS')">Time Table Viagens LOTS</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/timeTableSESE')">Time Table Viagens SESE</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/relatorioInterplantas')">Viagens Manuais -
              Crítico</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/carregaJettaInterplantas')">Carrega Jetta</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/ocupacaoTrucks')">Ocupação dos caminhões</button>
          </div>
        </div>

        <div class="dropdown separado" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
          <button class="dropbtn">Container</button>
          <div class="dropdown-content" *ngIf="showDropdown">
            <button class="btn btn-dropdown" (click)="navigateTo('/container')">Containers Importação</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/containerExp')">Containers Exportação</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/containerDTA')">Containers DTA</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/containerLC')">Containers LC Pneus</button>
            <!-- <button class="btn btn-dropdown" (click)="navigateTo('/container')">Time Table</button> -->
            <button class="btn btn-dropdown" (click)="navigateTo('/uploadContainer')">Upload Containers
              Importação</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/uploadContainerExp')">Upload Containers Exportação
            </button>
          </div>
        </div>

        <!-- <div class="dropdown separado" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
          <button class="dropbtn">Diretos</button>
          <div class="dropdown-content" *ngIf="showDropdown">
            <button class="btn btn-dropdown" (click)="navigateTo('/diretos')">Acompanhar Operação</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/uploadDiretos')">Upload Excel</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/input-diretos')">Viagens Diretas</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/input-diretos-extra')">Viagens Extra Diretas</button>
          </div>
        </div> -->

        <div class="dropdown separado" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
          <button class="dropbtn">Diretos</button>
          <div class="dropdown-content" *ngIf="showDropdown">
            <div class="dropdown" (mouseenter)="showDropdownTCM = true" (mouseleave)="showDropdownTCM = false">
              <button class="btn lcb btn-dropdown">Diretos LCB</button>
              <div class="dropdown-content-sub" *ngIf="showDropdownTCM">
                <button class="btn lcb btn-dropdown" (click)="navigateTo('/input-diretos-lcb')">LCB Fornecedor</button>
                <button class="btn lcb btn-dropdown" (click)="navigateTo('/input-diretos-lcb-extra')">LCB Extra</button>
              </div>
            </div>

            <div class="dropdown" (mouseenter)="showDropdownJSL = true" (mouseleave)="showDropdownJSL = false">
              <button class="btn sla btn-dropdown">Diretos SLA</button>
              <div class="dropdown-content-sub" *ngIf="showDropdownJSL" (mouseenter)="showDropdownJSL = true"
                (mouseleave)="showDropdownJSL = false">
                <button class="btn sla btn-dropdown" (click)="navigateTo('/input-diretos')">SLA Fornecedor</button>
                <button class="btn sla btn-dropdown" (click)="navigateTo('/input-diretos-extra')">SLA Extra</button>
              </div>
            </div>
          </div>
        </div>

        <div class="dropdown separado" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
          <button class="dropbtn">Frete Extra</button>
          <div class="dropdown-content" *ngIf="showDropdown">
            <button class="btn btn-dropdown" (click)="openManual()">Como solicitar um Frete Extra?</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/extra')">Acompanhar Operação</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/extra-concluded')">Fretes Concluídos</button>
          </div>
        </div>

        <div *ngIf="this.usuarioLogado && this.usuarioLogado.role == '9'" class="dropdown separado" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
          <button class="dropbtn">Motoboy</button>
          <div class="dropdown-content" *ngIf="showDropdown">
            <button class="btn btn-dropdown" (click)="navigateTo('/extra-motoboy')">Acompanhar Operação</button>
            <!-- <button class="btn btn-dropdown" (click)="navigateTo('/extra-concluded')">Fretes Concluídos</button> -->
          </div>
        </div>

        <div class="dropdown separado" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
          <button class="dropbtn">Aéreo</button>
          <div class="dropdown-content" *ngIf="showDropdown">
            <button class="btn btn-dropdown" (click)="navigateTo('/viagensAereo')">Acompanhar Operação</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/viagensAereoFinalizada')">Processos Finalizados</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/aereo')">Carregar Viagens</button>
          </div>
        </div>

        <div class="dropdown separado" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
          <button class="dropbtn">Time Table</button>
          <div class="dropdown-content" *ngIf="showDropdown">
            <!-- <button class="btn btn-dropdown" (click)="navigateTo('/timeTableMR')">Time Table SLA</button> -->
            <button class="btn btn-dropdown" (click)="navigateTo('/timeTableLCB')">Time Table LCB</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/timeTableSCANIA')">Time Table SCANIA</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/timeTableSCANIAEXP')">Time Table SCANIA KD
              EXPEDIÇÃO</button>
          </div>
        </div>

        <div class="dropdown separado" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
          <button class="dropbtn">Operação VW</button>
          <div class="dropdown-content" *ngIf="showDropdown">
            <!-- <button class="btn btn-dropdown" (click)="navigateTo('/operacaoVW')">Acompanhar Operação</button> -->
            <div class="dropdown" (mouseenter)="showDropdownJSLVW = true" (mouseleave)="showDropdownJSLVW = false">
              <button class="btn btn-dropdown">JSL</button>
              <div class="dropdown-content-sub" *ngIf="showDropdownJSLVW" (mouseenter)="showDropdownJSLVW = true"
                (mouseleave)="showDropdownJSLVW = false">
                <button class="btn btn-dropdown" (click)="navigateTo('/JSLVW')">Acompanhar
                  Operação</button>
              </div>
            </div>
            <div class="dropdown" (mouseenter)="showDropdownJSLItaquaVW = true"
              (mouseleave)="showDropdownJSLItaquaVW = false">
              <button class="btn btn-dropdown">JSL Itaqua</button>
              <div class="dropdown-content-sub" *ngIf="showDropdownJSLItaquaVW"
                (mouseenter)="showDropdownJSLItaquaVW = true" (mouseleave)="showDropdownJSLItaquaVW = false">
                <button class="btn btn-dropdown" (click)="navigateTo('/JSLVWItaqua')">Acompanhar
                  Operação</button>
              </div>
            </div>
            <div class="dropdown" (mouseenter)="showDropdownTCMVW = true" (mouseleave)="showDropdownTCMVW = false">
              <button class="btn btn-dropdown">TCM</button>
              <div class="dropdown-content-sub" *ngIf="showDropdownTCMVW" (mouseenter)="showDropdownTCMVW = true"
                (mouseleave)="showDropdownTCMVW = false">
                <button class="btn btn-dropdown" (click)="navigateTo('/TCMVW')">Acompanhar
                  Operação</button>
              </div>
            </div>
            <div class="dropdown" (mouseenter)="showDropdownTCMSBCVW = true"
              (mouseleave)="showDropdownTCMSBCVW = false">
              <button class="btn btn-dropdown">TCM SBC</button>
              <div class="dropdown-content-sub" *ngIf="showDropdownTCMSBCVW" (mouseenter)="showDropdownTCMSBCVW = true"
                (mouseleave)="showDropdownTCMSBCVW = false">
                <button class="btn btn-dropdown" (click)="navigateTo('/TCMSBCVW')">Acompanhar
                  Operação</button>
              </div>
            </div>
            <div class="dropdown" (mouseenter)="showDropdownSESEVW = true" (mouseleave)="showDropdownSESEVW = false">
              <button class="btn btn-dropdown">SESE</button>
              <div class="dropdown-content-sub" *ngIf="showDropdownSESEVW" (mouseenter)="showDropdownSESEVW = true"
                (mouseleave)="showDropdownSESEVW = false">
                <button class="btn btn-dropdown" (click)="navigateTo('/SESEVW')">Acompanhar
                  Operação</button>
              </div>
            </div>
            <button class="btn btn-dropdown" (click)="navigateTo('/atualizaVW')">Carregar Excel</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/trackingVW')">Tracking</button>
          </div>
        </div>

        <div class="dropdown separado" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
          <button class="dropbtn">Relatórios</button>
          <div class="dropdown-content" *ngIf="showDropdown">
            <button class="btn btn-dropdown" (click)="navigateTo('/relatorio')">Relatório Geral</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/control-center')">Controle Entrada/Saida</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/briefing')">Briefing</button>
            <button class="btn btn-dropdown" (click)="navigateTo('/volumesLCB')">Previsão volumes LCB</button>
            <!-- <button class="btn btn-dropdown" 
              (click)="navigateTo('/relatorioInterplantasAutomatico')">Relatorio
              Interplantas</button> -->
          </div>
        </div>

        <div class="dropdown separado" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
          <button class="dropbtn">Rastreamento</button>
          <div class="dropdown-content" *ngIf="showDropdown">
            <button class="btn btn-dropdown" (click)="navigateTo('/tracking')">Rastreamento dos
              Veículos</button>
          </div>
        </div>

        <div class="dropdown" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
          <button class="dropbtn">Painel</button>
          <div class="dropdown-content" *ngIf="showDropdown">
            <button class="btn btn-dropdown" (click)="navigateTo('/painel')">Painel</button>
          </div>
        </div>

      </div>
    </div>
    <div id="navbarNav">
      <div class="dropdown" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
        <div class="icone-setting">
          <i-feather name="settings"></i-feather>
          <button class="dropbtn">Configurações</button>
        </div>
        <div class="dropdown-content" *ngIf="showDropdown">
          <!-- <button class="btn btn-dropdown" [disabled]="isCarrierEnabled" (click)="navigateTo('/jetta')">Sinc
          Jetta</button> -->
          <!-- <button class="btn btn-dropdown" [disabled]="isCarrierJSLARGEnabled" (click)="navigateTo('/atualiza')">Sinc
          Excel</button> -->
          <button class="btn btn-dropdown" (click)="navigateTo('/cadastro')">Usuários</button>
          <button class="btn btn-dropdown" (click)="navigateTo('/contratos')">Contratos</button>
          <button class="btn btn-dropdown" (click)="navigateTo('/fornecedores')">Fornecedores</button>
          <button class="btn btn-dropdown" (click)="navigateTo('/locais')">Recebimentos Scania</button>
          <!-- <button class="btn btn-dropdown" (click)="navigateTo('/carrier">Transportadoras</button> -->
          <button class="btn btn-dropdown" (click)="navigateTo('/lab')">Veiculos Lab</button>
          <button class="btn btn-dropdown" (click)="navigateTo('/tipos')">Veículos MilkRun</button>
          <button class="btn btn-dropdown" (click)="navigateTo('/veiculosAereo')">Veículos fluxo aéreo</button>
          <button class="btn btn-dropdown" (click)="navigateTo('/carriers')">Transportadores</button>
          <button class="btn btn-dropdown" (click)="navigateTo('/cadastroTransportadorExtra')">Transportadores Frete
            Extra</button>

        </div>
      </div>

      <div class="dropdown" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
        <button class="dropbtn" type="button" (click)="logout()">Login/Logout</button>
        <!-- <button *ngIf="!usuario"  class="dropbtn" type="button" (click)="login()">Login</button> -->
      </div>

    </div>
    <!-- teste novo branch -->
  </nav>
</div>